import AxiosInstance from "./api";

export const DemandDepositService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/demand-deposits/paginate", {
      params: query,
    });
  },

  getById: async (id) => {
    return await AxiosInstance.get("/private/demand-deposits/" + id);
  },

  create: async (payload) => {
    return await AxiosInstance.post("/private/demand-deposits", payload);
  },

  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/demand-deposits/" + id, payload);
  },

  delete: async (id) => {
    return await AxiosInstance.delete("/private/demand-deposits/" + id);
  },
};
